import React from 'react';
import { inject, observer } from 'mobx-react';
import H5TopicList from './h5';
import PCTopicList from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { TopicAction } from '@stores/topic/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Toast from '@components/Toast';
interface TopicListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    topic?: TopicAction;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式
    currentPage?: number;
    pageSize?: number;
    data?: any
    namespace?: string; // 允许外部指定 listStore 命名空间，默认 userList
    listStore?: any; // 允许外部传入自定义 listStore（例如 topic.listStore）
    topicList: any   // 用户列表
    handleFollowToggleCallBack?: any  // 取消关注、关注话题
    searchKeyword?: any

}
type TopicListAllProps = TopicListProps & RouteComponentProps;
interface TopicListState {
    topicList: any
}
@inject('app', 'site', 'user', 'topic')
@observer
class TopicList extends React.Component<TopicListAllProps, TopicListState> {
    constructor(props) {
        super(props);

        // 从 props 中获取初始值设置到 state
        this.state = {
            topicList: props.topicList || [],
        };
    }
    componentDidMount() {
        // 可以在这里添加初始化逻辑

    }

    componentDidUpdate(prevProps) {
        // 当 props.userList 变化时更新 state
        if (prevProps.topicList !== this.props.topicList) {
          this.setState({
            topicList: this.props.topicList || []
          });
        }
    }

    // 关注/取消关注
    handleFollowToggle = async (item, index) => {
        
        let { topicList } = this.state;
        const { topic, handleFollowToggleCallBack } = this.props;
        console.log('话题', '+----',item.isFollowed);
        if (!item || !item.id) {
            console.warn('话题ID不存在');
            return;
        }
        if (item.isFollowed) {
            // 取消关注
            topic.createTopicsUnFollow(item.id).then(res => {
                // console.log('走了么');
                if (res.success === true) {
                    const updatedList = topicList.map((item, idx) => {
                        if (idx === index) {
                            return {
                                ...item,  // 复制原对象所有属性
                                isFollowed: false,  // 更新 isFollowed
                            };
                        }
                        return item;
                    });
                    handleFollowToggleCallBack && handleFollowToggleCallBack();
                    this.setState({
                        topicList: updatedList
                    });
                }
                
            });
        } else {
            // 关注
            topic.createTopicsFollow(item.id).then(res => {
                if (res.success === true) {
                    const updatedList = topicList.map((item, idx) => {
                        if (idx === index) {
                            return {
                                ...item,  // 复制原对象所有属性
                                isFollowed: true,  // 更新 isFollowed
                            };
                        }
                        return item;
                    });
                    handleFollowToggleCallBack && handleFollowToggleCallBack();
                    this.setState({
                        topicList: updatedList
                    });
                }
            });
        }
    };

    // // 处理触底加载下一页
    // handleLoadMore = () => {
    //     const { thread, namespace = 'threadList' } = this.props;
    //     if (!thread) return;

    //     const list = thread.listStore.lists[namespace];
    //     if (!list) return;

    //     // 获取当前页码，默认从1开始
    //     const currentPage = list.attribs?.page || 1;
    //     const pageSize = list.attribs?.pageSize || 20;

    //     // 构建查询参数并加载下一页
    //     const params: any = {
    //         'page[number]': currentPage + 1,
    //         'page[size]': pageSize,
    //     };

    //     // 如果有其他查询条件（如分类过滤），也需要传递
    //     if (list.search?.filter) {
    //         params.filter = list.search.filter;
    //     }

    //     // 根据命名空间调用对应的接口；目前只有 threadList 走 getThreadList
    //     if (namespace === 'threadList') {
    //         thread.getThreadList(params);
    //     }
    // };


    // 去话题详情
    goTopic = (item) => {
        if (this.props.history && item.id) {
            // this.props.history.push(`/topicDetail/${item.id}`);
            window.open(`/topicDetail/${item.id}`);
        }
    }

    

    render() {
        const { site, app, data, onLoadMore, loading: propsLoading, hasMore: propsHasMore, searchKeyword, loading, hasMore, listStore, emptyText,  emptyIcon, emptyBoxStyle, ...props } = this.props;
        const platform = app?.platform || 'h5';
        let { topicList } = this.state;
        // 确保传递 data 属性，即使为空数组
        const postListData = data || [];

        // 优先使用父组件传递的 loading 和 hasMore，如果没有则从 thread store 获取
        // const store = listStore || user?.listStore;
        // const loading = propsLoading !== undefined ? propsLoading : (store?.lists[namespace]?.loading || false);
        // const hasMore = propsHasMore !== undefined ? propsHasMore : (store?.lists[namespace]?.hasMore ?? true);

        // 优先使用父组件传递的 onLoadMore，如果没有则使用默认的 handleLoadMore
        // const loadMoreHandler = onLoadMore || this.handleLoadMore;

        if (platform === 'pc') {
            return <PCTopicList
                handleFollowToggle={this.handleFollowToggle}
                goTopic={this.goTopic}
                {...props}
                data={postListData}
                topicList={topicList}
                loading={loading}
                hasMore={hasMore}
                onLoadMore={onLoadMore || (() => { })}
                searchKeyword={searchKeyword}
                emptyText={emptyText}
                emptyIcon={emptyIcon}
                emptyBoxStyle={emptyBoxStyle}
             />;
        } else {
            return <H5TopicList
            handleFollowToggle={this.handleFollowToggle}
            goTopic={this.goTopic}
            {...props}
            topicList={topicList}
            data={postListData}
            loading={loading}
            hasMore={hasMore}
            onLoadMore={onLoadMore || (() => { })}
            searchKeyword={searchKeyword}
            emptyText={emptyText}
            emptyIcon={emptyIcon}
            emptyBoxStyle={emptyBoxStyle}
        />;
        }
    }
}

export default withRouter(TopicList);